<template>

<v-dialog v-model="dialog" width="500px">
  <v-card>
    <p class=".title ma-2">Refund via Pay.nl</p>
    <v-form ref="addHobr" v-model="addHobrValid">

      <v-row no-gutters>
        <v-col cols="8" class="pa-2">
          <v-text-field v-model="hobr_bedrag" required label="Amount" :prefix=hobr.valu_code type="number" :rules="hobr_bedragRules"></v-text-field>
        </v-col>
      </v-row>

    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="addHobr" :disabled="!addHobrValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      addHobrValid: false,
      hobo_encrid: null,
      hobr_bedrag: null,
      hobr: {},
      hobr_bedragRules: [
          v => (v && v.length >= 1) || "An amount is required"
      ]    
    }
  },
  methods: {
    open(hobo_encrid) {
      this.hobo_encrid = hobo_encrid;
      this.dialog = true;
    },
    addHobr() { 
      this.$axios
        .post("ares/json/ares/huov/hobo/addHobr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addHobr"
          },
          addHobr: {
            hobo_encrid: this.hobo_encrid,
            hobr_bedrag: parseFloat(this.hobr_bedrag)
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             if (res.data.addHobr.color == "success") { 
                setTimeout(() => { this.$router.reload('/huov/onHuov/' + res.data.addHobr.huov_encrid); }, 2000);      
             }  
                    
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.addHobr.text,
              color: res.data.addHobr.color
            }); 
            this.dialog = false;
          }
        })
    },
  }
}
</script>

